/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

// Esempio:
// exports.onRouteUpdate = ({ location, action }) => {
//     console.log('route changed!', { location, action })
// }

/** The SideBarBtns class */
class SideBarBtns {

    /** Used to register the scroll event handler */
    Initialize() {
        if (document.getElementById('scrollbtn') !== null) {
            // console.log('-- Initialize -> dentro IF');
            /** When the user scrolls down 300px from the top of the document, show the buttons */
            window.addEventListener("scroll", this.ToggleButtons)
            /** Event handler for scroll to top button */
            document.getElementById("scrollbtn").addEventListener("click", this.ScrollToTop);
        }
    }

    /** Displays/Hides the buttons */
    ToggleButtons() {
        if (document.getElementById('scrollbtn') !== null) {
            // console.log('-- -- ToggleButtons -> dentro IF');
            /** If the current current scroll is 300px or more */
            if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                // console.log('-- -- ToggleButtons -> dentro IF - 2');
                /** The scroll to top button is displayed */
                document.getElementById("scrollbtn").style.display = "block";
            } else {
                // console.log('-- -- ToggleButtons -> dentro IF -> ELSE - 3')
                /** The scroll to top button is hidden */
                document.getElementById("scrollbtn").style.display = "none";
            }
        }
    }

    /** When the user clicks on the button, scroll to the top of the document */
    ScrollToTop() {
        // console.log('-- -- ScrollToTop');
        /** The user is scrolled to the top of the page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}

exports.onRouteUpdate = ({ location, action }) => {
    /** The SideBarBtns object is created */
    let sidebarbtns = new SideBarBtns();
    /** If the current page is an article page */
    if (document.getElementById("scrollbtn")) {
        // console.log('dentro if');
        /** The SideBarBtns object is initialized */
        sidebarbtns.Initialize();
    }
}

exports.onServiceWorkerUpdateReady = () => { window.location.reload(true) };
